export const CMS_BLOCK = {
  MEGA_MENU_SHOP: 'livbrite_main_menu_shop_products',
  MEGA_MENU_INSPIRATION: 'livbrite_main_menu_inspiration',
  FOOTER_CONTACT: 'livbrite_footer_contact',
  FOOTER_COMMUNITY: 'livbrite_footer_community',
  FOOTER_QUICK_LINKS: 'livbrite_footer_quick_links',
  FOOTER_NEWSLETTER: 'livbrite_footer_newsletter_sign_up',
  FOOTER_LEGAL: 'livbrite_footer_legal',
  HOME_HEADER: 'home_header',
  HOME_SURVEY: 'home_survey',
  HOME_LIFESTYLE: 'home_lifestyle',
  HOME_INSPIRATION: 'home_inspiration',
  HOME_COMMUNITY: 'home_community_liv',
  SIZE_CHART_BOTTOM: 'size_chart_bottom',
  PS_NO_RESULTS: 'livbrite_ps_no_results',
  PROMO_BANNER: 'livbrite_promo_banner',
  ORDER_SUCCESS_CONTENT_LB: 'order_success_content_lb'
}

export const MENU_ITEMS = [
  {
    label: 'Shop Products',
    url: 'shop',
    block: CMS_BLOCK.MEGA_MENU_SHOP
  },
  {
    label: 'Inspiration and Advice',
    url: 'blog',
    block: CMS_BLOCK.MEGA_MENU_INSPIRATION
  }
]

export const MONTH_OPTIONS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Jan',
    value: '01'
  },
  {
    label: 'Feb',
    value: '02'
  },
  {
    label: 'Mar',
    value: '03'
  },
  {
    label: 'Apr',
    value: '04'
  },
  {
    label: 'May',
    value: '05'
  },
  {
    label: 'Jun',
    value: '06'
  },
  {
    label: 'Jul',
    value: '07'
  },
  {
    label: 'Aug',
    value: '08'
  },
  {
    label: 'Sep',
    value: '09'
  },
  {
    label: 'Oct',
    value: '10'
  },
  {
    label: 'Nov',
    value: '11'
  },
  {
    label: 'Dec',
    value: '12'
  }
]

export const GENDER_OPTIONS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Female',
    value: '2'
  },
  {
    label: 'Male',
    value: '1'
  },
  {
    label: 'Other',
    value: '3'
  },
  {
    label: 'Prefer not to say',
    value: '4'
  }
]

export const COMMUNITY_YES_NO = [
  {
    label: 'No',
    value: false
  },
  {
    label: 'Yes',
    value: true
  }
]

export const PRODUCT_SELECTOR_CODE = {
  SURVEY: 'LB-wellness-survey',
  SELECTOR: 'LB-incontinence-quiz'
}

export const DEMO_RESULTS = [
  {
    available_frequencies: [0],
    categories: ['Default Category', 'Bladder Control'],
    name: 'test product',
    short_description: 'The loss of voluntary control of our bladder or bowel can leave you frustrated, embarrassed, and less likely to get involved in the activities that bring you joy and move you toward your life goals. Urinary incontinence is much more common, but both are linked to medical and nonmedical issues. LivBrite brings you articles, tools, and recommendations to help you find solutions and manage or remove incontinence from being a barrier to living a good life.',
    thumbnail: '',
    url_key: '/product-selector',
    articles: '/blog/category/bladder-control-articles'
  },
  {
    available_frequencies: [0],
    categories: ['Default Category', 'Mobility'],
    name: 'test product',
    short_description: 'Do you play sports or hike or just want to be able to walk to one of your favorite spots in or near your home? Remaining physically active and moving the way you want to is a goal for almost everyone. When you cannot move freely and easily, your lack of mobility becomes a barrier to a fully involved life. There are many reasons for mobility challenges. In this section, LivBrite provides articles on topics to educate you on the ways to overcome mobility issues while providing resources and products to help you become more physically active. Moving is strongly linked to improved health and wellness.',
    thumbnail: '',
    url_key: '/mobility',
    articles: '/blog/category/mobility-articles'
  },
  {
    available_frequencies: [0],
    categories: ['Default Category', 'Nutrition'],
    name: 'test product',
    short_description: 'When you are hungry, what do you put in your body? Does it provide you the nutrients and energy you need? Eating well can improve your physical body as well as your memory and your mental state. Proper nutrition gives you energy, helps control weight, and can help prevent some chronic diseases such as cancer, diabetes, and osteoporosis. In this section, LivBrite presents current information on nutrition, ways to assess your eating, and products and services that help you eat well. Good nutrition forms the basis for good health, something you must have as you improve your life.',
    thumbnail: '',
    url_key: '/nutrition',
    articles: '/blog/category/nutrition-articles'
  }
]
